module.exports = __webpack_public_path__ + "media/img/download_app_store_white@3x-4af003dd.svg";